import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
	const [isDarkMode, setIsDarkMode] = useState(false);

	useEffect(() => {
		const stored = localStorage.getItem("theme");
          if(!stored) localStorage.setItem("theme", "light"); 
		const prefersDark = stored === "dark" || (!stored && window.matchMedia("(prefers-color-scheme: dark)").matches);
		setIsDarkMode(prefersDark);
	}, []);

	useEffect(() => {
    
		// localStorage.setItem("theme", isDarkMode ? "dark" : "light");
		const html = document.documentElement;
		if (isDarkMode) {
			html.classList.add("dark");
		} else {
			html.classList.remove("dark");
		}
	}, [isDarkMode]);


	return (
		<ThemeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useThemeMode = () => useContext(ThemeContext);